// getSign

import md5 from './md5'

const appkey = import.meta.env.VITE_APP_ENV === 'production' ? 'xRj3kx7iAznAzqBUkMnj0DUC8/u4iz2dpx1CifuRqyY=' : 'wnsmh01KAEhjqOr2I7iI6x91v8jeUZCovfrqPLlffVQ='

export function getSign(params) {
  // console.log('params',params)
  // 如果入参有undefined，统一置为""
  for (let item in params) {
    if (params[item] == undefined) {
      params[item] = ''
    }
  }
  params.timestamp = new Date().getTime().toString()

  //生成key升序数组
  let arr = Object.keys(params)
  let str = ''

  arr.sort()
  for (let i in arr) {
    if (typeof params[arr[i]] == 'object') {
      str += ''
    } else {
      str += params[arr[i]]
    }
  }

  params.sign = md5(str + appkey)

  return params
}
